"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialForm = void 0;
var getInitialForm = function (initialState) { return function () { return initialState; }; };
exports.getInitialForm = getInitialForm;
//# sourceMappingURL=getInitialForm.js.map